import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()({
    gridContainer: {
        marginTop: "32px",
    },
});
